import { Check } from '@mui/icons-material';
import { Grid, TextField } from '@mui/material';
import { usePolicyStore } from '@store/policyStore';
interface InputCouponProps {
  isTablet: boolean;
  coupon: string;
  couponError: string;
  setCoupon: (coupon: string) => void;
  discount: {
    name: string;
    value: string;
  };
}

export const InputCoupon: React.FC<InputCouponProps> = ({
  isTablet,
  coupon,
  couponError,
  setCoupon,
  discount,
}) => {
  const { policy, addPolicyInfo } = usePolicyStore();
  const handleClick = (code_name: any) => {
   // policy.code = code_name;
   //addPolicyInfo({ ...policy });
    setCoupon(code_name);
  };

  return (
    <Grid
      container
      display={'flex'}
      flexDirection={'row'}
      alignItems={'flex-start'}
    >
      <Grid xs={12} item lg={12}>
        <TextField
          fullWidth
          label="Código de promoción"
          variant="outlined"
          value={coupon}
          helperText={couponError}
          error={couponError.length > 0}
          color={
            discount.name !== '' && couponError.length < 1
              ? 'success'
              : 'primary'
          }
          onChange={({ target }) =>
            handleClick(target.value.toUpperCase().trim())
          }
          style={
            isTablet
              ? { borderRadius: '8px' }
              : { borderRadius: '8px', width: '98%' }
          }
          InputProps={{
            style: {
              borderRadius: 8,
            },
            endAdornment:
              discount.name !== '' && couponError.length < 1 ? (
                <Check color={'success'} />
              ) : null,
          }}
        />
      </Grid>
    </Grid>
  );
};
